var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasErrors
    ? _c(
        "div",
        {
          staticClass:
            "con-text-validation span-text-validation-danger v-enter-to"
        },
        [
          _vm.customError !== ""
            ? _c("span", { staticClass: "span-text-validation" }, [
                _vm._v(" " + _vm._s(_vm.customError) + " ")
              ])
            : _c("span", { staticClass: "span-text-validation" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.validatorErrors.first(
                        _vm.document + "." + _vm.validation
                      )
                    ) +
                    " "
                )
              ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }